import React, { useState, useRef } from "react";
import Card from "components/Card/Card";
import { Col, ControlLabel, FormGroup, Grid, Row } from "react-bootstrap";
import NotificationSystem from "react-notification-system";
import Button from "components/CustomButton/CustomButton.jsx";
import Swal from "sweetalert2";
import Axios from "axios";

const GoodReturnNoteBulkUpload = () => {
  const token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const store = token.store_id;

  const notificationSystem = useRef(null);
  const fileInputRef = useRef(null);

  const [profile, setProfile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [uploaded, setUploaded] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setProfile(file);
      setLoading(true);
      setUploaded(false);

      setTimeout(() => {
        setLoading(false);
        setUploaded(true);
      }, 4000);
    }
  };

  const upload = () => {
    fileInputRef.current.click();
  };

  const sampleDownload = () => {
    window.open(
      "https://flash-prod.s3.ap-south-1.amazonaws.com/calorie_data/SampleExcel.xlsx"
    );
  };

  const onSubmit = async () => {
    if (!profile || isSubmitting) return;
    const result = await Swal.fire({
      width: "500px",
      title:
        "<div style='font-size:26px;font-weight:100;'>Do you want to good return this?</div>",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "<font size='4px'>Yes</font>",
      cancelButtonText: "<font size='4px'>No</font>",
      allowOutsideClick: false,
      showCloseButton: true,
    });
    if (!result.isConfirmed) return;
    setIsSubmitting(true);
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    const fdata = new FormData();
    fdata.append("csv_file", profile);
    fdata.append("store_id", store);

    const url =
      process.env.REACT_APP_NOT_SECRET_CODE + "/good-return/bulk_upload";
    try {
      const res = await Axios.post(url, fdata, {
        headers: {
          Authorization: "Bearer " + obj,
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          "X-Request-Id": "124",
        },
      });
      await Swal.fire({
        width: "480px",
        title: `<font size='5px'>${res.data.message}</font>`,
        icon: "success",
        confirmButtonText: "<font size='4px'>OK</font>",
      });
      setResponse(res.data.message);
      setProfile(null);
      setUploaded(false);
    } catch (error) {
      const errorData = error.response && error.response.data;
      let errorMessage = "Something went wrong";
      if (errorData) {
        if (errorData.errors && errorData.errors.length > 0) {
          const errorText = errorData.errors.join(", ");
          errorMessage = `<div style="text-align:center; font-size:16px; line-height:1.5;">${errorText}</div>`;
        } else if (errorData.message) {
          errorMessage = `<div style="text-align:center; font-size:16px; line-height:1.5;">${errorData.message}</div>`;
        }
      }
      await Swal.fire({
        width: "480px",
        title: "<font size='5px'>Processing Failed!</font>",
        html: errorMessage,
        icon: "error",
        confirmButtonText: "<font size='4px'>OK</font>",
      });
    } finally {
      setIsSubmitting(false);
      setProfile(null);
      setUploaded(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    }
  };

  return (
    <div className="main-content">
      <NotificationSystem ref={notificationSystem} />
      <Grid fluid>
        <Row>
          <Col md={6}>
            <Card
              tableFullWidth
              content={
                <>
                  <Row style={{ padding: "20px" }}>
                    <Col md={12}>
                      <FormGroup>
                        <ControlLabel>Good Return Bulk Upload</ControlLabel>
                        <br></br>
                        <input
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          type="file"
                          accept=".xlsx,.xls"
                          onChange={handleFileChange}
                        />
                        <div style={{ display: "flex", gap: "15px" }}>
                          <Button
                            type="button"
                            onClick={upload}
                            style={{ color: "#2B3A41" }}
                          >
                            <i
                              className={
                                !profile ? "fa fa-plus" : "fa fa-pencil fa-fw"
                              }
                            ></i>{" "}
                            {!profile ? "Choose Excel" : "Change Excel"}
                          </Button>

                          <div style={{ marginTop: "10px" }}>
                            {loading && (
                              <div class="spinner-border" role="status">
                                <span class="visually-hidden">Loading...</span>
                              </div>
                            )}
                            {uploaded && !loading && (
                              <i
                                className="fa fa-check-square"
                                style={{
                                  color: "green",
                                  fontSize: "24px",
                                  verticalAlign: "super",
                                }}
                              ></i>
                            )}
                          </div>
                        </div>
                      </FormGroup>
                      <Button
                        className="fl_btn_add_order btn-fill btn btn-default"
                        onClick={onSubmit}
                        fill
                        disabled={!uploaded || isSubmitting}
                      >
                        {isSubmitting ? "Submitting..." : "Submit"}
                      </Button>
                      <br></br>
                      <div style={{ marginTop: "30px" }}>
                        <Button
                          class="btn-fill btn btn-default"
                          onClick={sampleDownload}
                          fill
                        >
                          Download Sample Excel
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </>
              }
            />
          </Col>
        </Row>
      </Grid>
    </div>
  );
};

export default GoodReturnNoteBulkUpload;
